/**
 * CommentsViewToggle — toggle "Activos / Historial" compartido entre
 * `CommentsPanel` (editor) y `CommentsViewerPanel` (viewer).
 *
 * El comportamiento del toggle es idéntico en ambos casos: cambia el
 * sub-estado `view` del padre y éste decide qué query renderizar.
 * Vivía duplicado en cada panel; ahora hay una sola fuente.
 */

import { useTranslation } from 'react-i18next'

export type CommentsViewKey = 'active' | 'history'

export function CommentsViewToggle({
  view,
  onChange,
}: {
  view: CommentsViewKey
  onChange: (v: CommentsViewKey) => void
}) {
  const { t } = useTranslation('projects')
  return (
    <div className="shrink-0 flex items-center gap-1 border-b border-line px-3 py-2">
      <button
        type="button"
        onClick={() => onChange('active')}
        className={
          view === 'active'
            ? 'px-2.5 py-1 text-[11px] font-medium rounded-md bg-brand-soft text-brand'
            : 'px-2.5 py-1 text-[11px] font-medium rounded-md text-ink-muted hover:text-ink hover:bg-surface-muted transition-colors'
        }
      >
        {t('comments_panel.view_toggle.active')}
      </button>
      <button
        type="button"
        onClick={() => onChange('history')}
        className={
          view === 'history'
            ? 'px-2.5 py-1 text-[11px] font-medium rounded-md bg-brand-soft text-brand'
            : 'px-2.5 py-1 text-[11px] font-medium rounded-md text-ink-muted hover:text-ink hover:bg-surface-muted transition-colors'
        }
      >
        {t('comments_panel.view_toggle.history')}
      </button>
    </div>
  )
}
